var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 2C-0.000610352 1.44772 0.447105 1 0.99939 1H16.9994C17.5517 1 17.9994 1.44772 17.9994 2C17.9994 2.55228 17.5517 3 16.9994 3H0.99939C0.447105 3 -0.000610352 2.55228 -0.000610352 2Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 9C-0.000610352 8.44772 0.447105 8 0.99939 8H16.9994C17.5517 8 17.9994 8.44772 17.9994 9C17.9994 9.55228 17.5517 10 16.9994 10H0.99939C0.447105 10 -0.000610352 9.55228 -0.000610352 9Z",
    fill: "#1B1B1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 16C-0.000610352 15.4477 0.447105 15 0.99939 15H16.9994C17.5517 15 17.9994 15.4477 17.9994 16C17.9994 16.5523 17.5517 17 16.9994 17H0.99939C0.447105 17 -0.000610352 16.5523 -0.000610352 16Z",
    fill: "#1B1B1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99939 2C6.99939 3.10457 6.10396 4 4.99939 4C3.89482 4 2.99939 3.10457 2.99939 2C2.99939 0.895431 3.89482 0 4.99939 0C6.10396 0 6.99939 0.895431 6.99939 2Z",
    fill: "#1B1B1B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 9C14.9994 10.1046 14.104 11 12.9994 11C11.8948 11 10.9994 10.1046 10.9994 9C10.9994 7.89543 11.8948 7 12.9994 7C14.104 7 14.9994 7.89543 14.9994 9Z",
    fill: "#1B1B1B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99939 16C6.99939 17.1046 6.10396 18 4.99939 18C3.89482 18 2.99939 17.1046 2.99939 16C2.99939 14.8954 3.89482 14 4.99939 14C6.10396 14 6.99939 14.8954 6.99939 16Z",
    fill: "#1B1B1B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 2C-0.000610352 1.44772 0.447105 1 0.99939 1H16.9994C17.5517 1 17.9994 1.44772 17.9994 2C17.9994 2.55228 17.5517 3 16.9994 3H0.99939C0.447105 3 -0.000610352 2.55228 -0.000610352 2Z",
    fill: "#1B1B1B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 9C-0.000610352 8.44772 0.447105 8 0.99939 8H16.9994C17.5517 8 17.9994 8.44772 17.9994 9C17.9994 9.55228 17.5517 10 16.9994 10H0.99939C0.447105 10 -0.000610352 9.55228 -0.000610352 9Z",
    fill: "#1B1B1B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000610352 16C-0.000610352 15.4477 0.447105 15 0.99939 15H16.9994C17.5517 15 17.9994 15.4477 17.9994 16C17.9994 16.5523 17.5517 17 16.9994 17H0.99939C0.447105 17 -0.000610352 16.5523 -0.000610352 16Z",
    fill: "#1B1B1B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99939 2C6.99939 3.10457 6.10396 4 4.99939 4C3.89482 4 2.99939 3.10457 2.99939 2C2.99939 0.895431 3.89482 0 4.99939 0C6.10396 0 6.99939 0.895431 6.99939 2Z",
    fill: "#1B1B1B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9994 9C14.9994 10.1046 14.104 11 12.9994 11C11.8948 11 10.9994 10.1046 10.9994 9C10.9994 7.89543 11.8948 7 12.9994 7C14.104 7 14.9994 7.89543 14.9994 9Z",
    fill: "#1B1B1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99939 16C6.99939 17.1046 6.10396 18 4.99939 18C3.89482 18 2.99939 17.1046 2.99939 16C2.99939 14.8954 3.89482 14 4.99939 14C6.10396 14 6.99939 14.8954 6.99939 16Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.a25f2a4408d8f82350e0f904ff14b86f.svg";
export { ForwardRef as ReactComponent };